"use client";

import { c as _c } from "react/compiler-runtime";
import BagActiveIcon from "@/assets/svg/bag-active.svg";
import BagNormalIcon from "@/assets/svg/bag-normal.svg";
import ShoppingBagIcon from "@/assets/svg/icon-bag.svg";
import { authClient } from "@/lib/auth/auth-client";
import { cn } from "@/lib/utils";
import { useLocaleRouter } from "@/lib/utils.client";
interface CartButtonProps {
  variant?: "header" | "bottom-nav";
  isActive?: boolean;
  className?: string;
}

/**
 * 购物车按钮，处理点击事件（未登录则引导登录，已登录则跳转到购物车）。
 */
export function CartButton(t0) {
  const $ = _c(17);
  const {
    variant: t1,
    isActive: t2,
    className
  } = t0;
  const variant = t1 === undefined ? "header" : t1;
  const isActive = t2 === undefined ? false : t2;
  const router = useLocaleRouter();
  const {
    data: session
  } = authClient.useSession();
  const userProfile = session?.user;
  let t3;
  if ($[0] !== router || $[1] !== userProfile) {
    t3 = () => {
      if (!userProfile) {
        authClient.signIn.anonymous().then(() => {
          router.push("/shopping-cart");
        }).catch(_temp);
      } else {
        router.push("/shopping-cart");
      }
    };
    $[0] = router;
    $[1] = userProfile;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleClick = t3;
  if (variant === "bottom-nav") {
    const IconComponent = isActive ? BagActiveIcon : BagNormalIcon;
    let t4;
    if ($[3] !== className) {
      t4 = cn("flex items-center cursor-pointer", className);
      $[3] = className;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== IconComponent) {
      t5 = <IconComponent className="w-6 h-6" />;
      $[5] = IconComponent;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== handleClick || $[8] !== t4 || $[9] !== t5) {
      t6 = <div className={t4} onClick={handleClick}>{t5}</div>;
      $[7] = handleClick;
      $[8] = t4;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  let t4;
  if ($[11] !== className) {
    t4 = cn("flex items-center cursor-pointer border border-transparent", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ShoppingBagIcon className=" size-5.5 md:w-[24px] md:h-[24px]" />;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== handleClick || $[15] !== t4) {
    t6 = <div className={t4} onClick={handleClick}>{t5}</div>;
    $[14] = handleClick;
    $[15] = t4;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(error) {
  console.error("CartButton: \u767B\u5F55\u5931\u8D25", error);
}